//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeSubradaCiselAkciDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-21                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvsdde) GID:(Web.Set.Des.Ts) V1:(rok,ico,ixs_pla,subrada,nazev,maska,aktivita,dat_zmena,zmenu_prov,cislo_od,cislo_do) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeSubradaCiselAkciDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeSubradaCiselAkciDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - rok */
            public rok: number;
            /** PK - ico */
            public ico: string;
            /** PK - ixs_pla */
            public ixs_pla: string;
            /** PK - subrada */
            public subrada: number;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeSubradaCiselAkciListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeSubradaCiselAkciDesigner>, rok: number,ico: string,ixs_pla: string,subrada: number  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, rok,ico,ixs_pla,subrada);
            // vytvorim panel a umistim jej do hlavniho DIVu
            v_form.addRow("jres:33000146").addField("gselectbox", Gordic.Prefabs.Select.admSrvspla(), {
                /*graphicInput: "oninput",*/
                dropdown: false,
                name: "ixs_pla",
                model: "model.ixs_pla=value.ixs_pla",
                initialValue: ixs_pla ? { ixs_pla: ixs_pla } : null,
                disabled: ixs_pla ? true : false,
            })
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction, {
                hardDefaultFilter: {
                    ixs_pla: ixs_pla,
                    subrada: subrada,
                    rok: rok,
                    ico: ico
                }
            });
            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeSubradaCiselAkciDesigner>, rok: number,ico: string,ixs_pla: string,subrada: number ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeSubradaCiselAkciDesigner>, ev, ctx): any {
            var filterObj = {
                ixs_pla: SeznamBase.filterContains(ctx.filter, "ixs_pla")
            }
            that.view = new Gordic.Isl.View(that.isl.AdeSubradaCiselAkci.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeSubradaCiselAkciDesignerInit
         * 
         * @param {GContentType<SeznamAdeSubradaCiselAkciDesigner>} that
         */
        static SeznamAdeSubradaCiselAkciDesignerInit(that: GContentType<SeznamAdeSubradaCiselAkciDesigner>, rok: number,ico: string,ixs_pla: string,subrada: number ) {
            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, rok,ico,ixs_pla,subrada);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);
            this.LoadData(that, rok, ico, ixs_pla, subrada)
        } // SeznamAdeSubradaCiselAkciDesignerInit

        static LoadData(that: GContentType<SeznamAdeSubradaCiselAkciDesigner>, rok: number, ico: string, ixs_pla: string, subrada: number) {
            var filterObj: any = {};
            if (ixs_pla) {
                new Gordic.Data.Readers.AdmSrvspla().getData({ ixs_pla: ixs_pla }).done((o) => {
                    that.filter.findFields("ixs_pla").gfield("setInitial", o[0]);
                })
                filterObj.ixs_pla = ixs_pla;
            }
            that.view = new Gordic.Isl.View(that.isl.AdeSubradaCiselAkci.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });
        }

    }
}
